export default __webpack_public_path__ + "static/media/xlsChecked.30260cf8.svg";